<script setup>
import {ref, onMounted, onBeforeUnmount, computed} from 'vue';

// WebM is not in use anymore due to issues on iOS devices with multiple sources
const videos = [
  {
    mobile: {
      mp4: '/videos/Littupp-Mobile-Matur-phone.mp4',
      webm: '/videos/Littupp-Mobile-Matur-phone.webm',
    },
    desktop: {
      mp4: '/videos/Littupp-Desktop-Matur.mp4',
      webm: '/videos/Littupp-Desktop-Matur.webm',
    },
  },
  {
    mobile: {
      mp4: '/videos/Littupp-Mobile-Party-phone.mp4',
      webm: '/videos/Littupp-Mobile-Party-phone.webm',
    },
    desktop: {
      mp4: '/videos/Littupp-Desktop-Party.mp4',
      webm: '/videos/Littupp-Desktop-Party.webm',
    },
  },
  {
    mobile: {
      mp4: '/videos/Littupp-Mobile-Bio-phone.mp4',
      webm: '/videos/Littupp-Mobile-Bio-phone.webm',
    },
    desktop: {
      mp4: '/videos/Littupp-Desktop-Bio.mp4',
      webm: '/videos/Littupp-Desktop-Bio.webm',
    },
  },
];

const videoRef = ref();

const shuffledOrder = ref([]);
const currentIndex = ref(null);
const currentVideo = ref(null);

const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const initPlaylist = () => {
  const shuffled = shuffleArray(videos.keys());
  shuffledOrder.value = shuffled;
  currentIndex.value = shuffled[0];
};

const onVideoEnded = () => {
  currentIndex.value = (currentIndex.value + 1) % shuffledOrder.value.length;
  loadVideoSource();
};

const loadVideoSource = () => {
  currentVideo.value = videos[currentIndex.value];
};

const isMobile = ref(false);
let mq;

const updateFormat = () => {
  isMobile.value = mq.matches;
};

const videoSource = computed(() => {
  if (!currentVideo.value) {
    return null;
  }
  const { mobile, desktop } = currentVideo.value;
  return isMobile.value ? mobile.mp4 : desktop.mp4;
});

onMounted(() => {
  mq = window.matchMedia('(max-width: 608px)');
  updateFormat();
  mq.addEventListener('change', updateFormat);
  initPlaylist();
  loadVideoSource();
});

onBeforeUnmount(() => {
  mq?.removeEventListener('change', updateFormat);
});
</script>
<template>
  <video
      v-if="videoSource"
      @ended="onVideoEnded()"
      :key="currentIndex"
      ref="videoRef"
      muted
      playsinline
      autoplay
      class="absolute origin-center left-0 top-0 w-full h-full object-cover -z-10 block hero-shadow"
      :src="videoSource"
  >
  </video>
</template>

<style scoped>
.hero-shadow {
  -webkit-mask-image: linear-gradient(to bottom, black 90%, transparent 100%);
  -webkit-mask-composite: destination-in;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;

  mask-image: linear-gradient(to bottom, black 90%, transparent 100%);
  mask-composite: intersect;
  mask-repeat: no-repeat;
  mask-size: 100% 100%;
}
</style>
